<template>
  <el-container>
    <el-main>
      <h3>品牌聯盟的初衷</h3>
      <p>近年来，~~~~</p>
      <div class="img-box">
        <img src="/static/img/banner3.jpg" alt="company-concept">
      </div>
      <h3>品牌聯盟的定義</h3>
      <p>品牌聯盟”是由高雄發起，邀請各園區內合作力強，產品資源好，服務意識強的商戶共同組成，實現資源互通、利益共享、風險共擔的共同體。</p>
      <h3>品牌聯盟的功能</h3>

    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'BrandIntroduce'
}
</script>

<style scoped>
.el-main {
  padding: 0;
}

.img-box img {
  width: 100%;
}

.el-main p {
  line-height: 1.5;
  font-size: 1rem;
  text-indent: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/alliancepage/components/BrandIntroduce.vue